import moment from "moment";
import { SET_CHATBOT_SENDING, SET_CASE_ID, RESET_CONFIG_STATE, RESET_CHAT_STATE, GO_TO_ERROR_SCREEN, RECEIVE_CHAT_AN_ADVISOR, BACK_TO_QUEUE, LEAVING_QUEUE, DF_TIMED_QUEUE_JOIN_MESSAGE, DF_RESET_QUEUE_JOIN_MESSAGE, DF_REQUEST_CLIENT_END_CHAT, LEAVE_QUEUE, CYCLE_POSITION_MESSAGE, CYCLE_QUEUE_MESSAGE, RECEIVE_QUEUE_POSITION_MESSAGES, RECEIVE_QUEUE_MESSAGES, RECEIVE_AVERAGE_WAIT_TIME, RECEIVE_EVENT, SEND_EVENT, DF_RECEIVE_MESSAGES, AGENT_NOT_AVAILABLE_MESSAGE, SET_SEQUENCE, DF_RECEIVE_CHAT, DF_RECEIVE_INIT_CHASITOR, DF_RECEIVE_CREATE_SESSION, RECEIVE_CHAT_TRANSCRIPT, REQUEST_CHAT_TRANSCRIPT, SKIP_SUBMIT_RATING, RECEIVE_SUBMIT_RATING, SET_CHAT_STATUS, END_CHAT, ENDING_CHAT, RETURN_TO_CHAT, USE_SUGGESTION, UPDATE_CHAT, RECEIVE_CHAT, REQUEST_CHAT, SAVE_POSITION } from "./Constants.js";
import { CHAT_STATUS, MESSAGE_TYPE } from "../constants/index.js";
const initialState = {
  alreadyWelcomed: false,
  currentMessage: "",
  currentSuggestion: "",
  messageHistory: [],
  previousMessages: [],
  suggestions: [],
  state: CHAT_STATUS.DEFAULT,
  sending: false
};
const ChatBotReducer = (state = initialState, action) => {
  let newMessageHistory = [];
  const parcelNumber = window.location.pathname.split("/")[2];
  switch (action.type) {
    case SAVE_POSITION:
      return Object.assign({}, state, {
        positionBottom: action.bottom,
        positionRight: action.right
      });
    case REQUEST_CHAT:
      if (!action.message || action.message.trim() === "") return state;
      newMessageHistory = (state.messageHistory || []).concat([
        {
          source: "client",
          timestamp: moment().valueOf(),
          messages: [action.message]
        }
      ]);
      return Object.assign({}, state, {
        alreadyWelcomed: true,
        currentMessage: "",
        suggestions: [],
        currentSuggestion: "",
        messageHistory: newMessageHistory,
        sending: true
      });
    case RECEIVE_CHAT:
      let currentRichContent = null;
      const messages = action.result.messages.map((msg) => {
        if (!msg) return null;
        const richContent = {
          type: msg.type,
          content: msg.richContent
        };
        if (msg.richContent) {
          currentRichContent = richContent;
        }
        switch (msg.type) {
          case "welcome":
            return msg.message;
          case "default":
          case "liveagent":
            return msg.message;
          default:
            return richContent;
        }
      });
      newMessageHistory = (state.messageHistory || []).concat(
        messages.length ? [
          {
            source: "dpd",
            timestamp: moment().valueOf(),
            messages
          }
        ] : []
      );
      return Object.assign({}, state, {
        alreadyWelcomed: true,
        richContent: currentRichContent,
        messageHistory: newMessageHistory,
        suggestions: action.result.suggestions || [],
        state: CHAT_STATUS.DEFAULT,
        sending: false
      });
    case UPDATE_CHAT:
      return Object.assign({}, state, {
        currentMessage: action.message,
        lastKeypress: moment().valueOf()
      });
    case USE_SUGGESTION:
      return Object.assign({}, state, {
        currentMessage: action.suggestion,
        currentSuggestion: action.suggestion
      });
    case RETURN_TO_CHAT:
      return Object.assign({}, state, { state: CHAT_STATUS.DEFAULT });
    case ENDING_CHAT:
      return Object.assign({}, state, { state: CHAT_STATUS.ENDING });
    case END_CHAT:
      return Object.assign({}, state, {
        state: action.ratingEnabled ? CHAT_STATUS.ENDED : CHAT_STATUS.FINAL,
        dfLocalSession: Date.now()
      });
    case SET_CHAT_STATUS:
      return Object.assign({}, state, {
        state: action.chatStatus
      });
    case RECEIVE_SUBMIT_RATING:
    case SKIP_SUBMIT_RATING:
      return Object.assign({}, state, { state: CHAT_STATUS.FINAL });
    case REQUEST_CHAT_TRANSCRIPT:
      return Object.assign({}, state, { transcriptRequested: true });
    case RECEIVE_CHAT_TRANSCRIPT:
      return Object.assign({}, state, { transcriptRequested: false });
    case DF_RECEIVE_CREATE_SESSION:
      return Object.assign({}, state, {
        dfLocalSession: Date.now(),
        dfAffinity: action.result.affinityToken,
        dfTimeout: action.result.clientPollTimeout,
        dfId: action.result.id,
        dfKey: action.result.key,
        dfSequence: (state.dfSequence || 0) + 1
      });
    case DF_RECEIVE_INIT_CHASITOR:
    case DF_RECEIVE_CHAT:
      return Object.assign({}, state, {
        dfSequence: (state.dfSequence || 0) + 1,
        sending: false
      });
    case SET_SEQUENCE:
      return Object.assign({}, state, {
        dfSequence: action.sequence
      });
    case DF_RECEIVE_MESSAGES:
      const stateDiff = {
        messageHistory: state.messageHistory
      };
      (action.messages || []).forEach((message) => {
        switch (message.type) {
          case MESSAGE_TYPE.CHAT_REQUEST_SUCCESS:
            stateDiff.dfSuccess = true;
            stateDiff.dfQueue = message.message.queuePosition;
            break;
          case MESSAGE_TYPE.QUEUE_UPDATE:
            stateDiff.dfQueue = message.message.position;
            break;
          case MESSAGE_TYPE.CHAT_ESTABLISHED:
            stateDiff.dfEstablished = true;
            stateDiff.dfAdvisorName = message.message.name;
            stateDiff.messageHistory = (stateDiff.messageHistory || []).concat([
              {
                source: "_chat-notification",
                timestamp: moment().valueOf(),
                message: (state.dfAdvisorName || "Advisor") + " has entered the chat"
              }
            ]);
            break;
          case MESSAGE_TYPE.CHAT_ENDED:
            stateDiff.messageHistory = (stateDiff.messageHistory || []).concat([
              {
                source: "_chat-notification",
                timestamp: moment().valueOf(),
                message: (state.dfAdvisorName || "Advisor") + " has ended the chat"
              }
            ]);
            stateDiff.dfLocalSession = Date.now();
            stateDiff.dfSequence = 0;
            stateDiff.dfId = "";
            stateDiff.dfCaseId = "";
            stateDiff.liveAgentUrl = "";
            stateDiff.dfEstablished = false;
            stateDiff.dfAdvisorName = "";
            stateDiff.dfTyping = false;
            stateDiff.state = CHAT_STATUS.ADVISOR_ENDED;
            stateDiff.sending = false;
            break;
          case MESSAGE_TYPE.AGENT_TYPING:
            stateDiff.dfTyping = true;
            break;
          case MESSAGE_TYPE.AGENT_NOT_TYPING:
            stateDiff.dfTyping = false;
            break;
          case MESSAGE_TYPE.CHAT_MESSAGE:
            stateDiff.messageHistory = (stateDiff.messageHistory || []).concat([
              {
                source: "advisor",
                timestamp: moment().valueOf(),
                messages: [message.message.text]
              }
            ]);
            stateDiff.dfTyping = false;
            stateDiff.sending = false;
            break;
          case MESSAGE_TYPE.CHAT_REQUEST_FAIL:
            stateDiff.messageHistory = (state.messageHistory || []).concat([
              {
                source: "dpd",
                timestamp: moment().valueOf(),
                messages: [
                  AGENT_NOT_AVAILABLE_MESSAGE + (parcelNumber ? parcelNumber.split("*")[0] : "")
                ]
              }
            ]);
            stateDiff.dfSequence = 0;
            if (message.message.reason === "Unavailable" && state.state !== CHAT_STATUS.CALL_CENTER_CLOSED) {
              stateDiff.state = CHAT_STATUS.ADVISOR_BUSY;
            }
            stateDiff.sending = false;
            break;
        }
      });
      if (action.messages) {
        if (parseInt(stateDiff.dfQueue, 10) > 0) {
          stateDiff.state = CHAT_STATUS.QUEUE;
        } else if (state.state === CHAT_STATUS.QUEUE) {
          stateDiff.state = CHAT_STATUS.DEFAULT;
        }
      }
      return Object.assign({}, state, stateDiff);
    case SEND_EVENT:
      return Object.assign({}, state, {
        hadFmpAction: true,
        actionPending: true
      });
    case RECEIVE_EVENT:
      const diff = {
        actionPending: false
      };
      return Object.assign({}, state, diff);
    case RECEIVE_AVERAGE_WAIT_TIME:
      return Object.assign({}, state, {
        averageWaitTime: action.waitTime
      });
    case RECEIVE_QUEUE_MESSAGES:
      return Object.assign({}, state, {
        messages: action.queueMessages
      });
    case RECEIVE_QUEUE_POSITION_MESSAGES:
      return Object.assign({}, state, {
        queuePositionMessages: action.queueMessages
      });
    case CYCLE_QUEUE_MESSAGE:
      return Object.assign({}, state, {
        queueMessage: action.message
      });
    case CYCLE_POSITION_MESSAGE:
      return Object.assign({}, state, {
        positionMessage: action.message
      });
    case LEAVE_QUEUE:
      return Object.assign({}, state, {
        showPositionMessage: false,
        dfSequence: 0,
        state: CHAT_STATUS.DEFAULT,
        dfLocalSession: Date.now()
      });
    case DF_REQUEST_CLIENT_END_CHAT:
      return Object.assign({}, state, {
        dfId: "",
        dfSequence: 0,
        dfCaseId: "",
        liveAgentUrl: "",
        dfEstablished: false,
        dfAdvisorName: "",
        dfTyping: false
      });
    case DF_RESET_QUEUE_JOIN_MESSAGE:
      return Object.assign({}, state, {
        showPositionMessage: false
      });
    case DF_TIMED_QUEUE_JOIN_MESSAGE:
      return Object.assign({}, state, {
        showPositionMessage: true
      });
    case LEAVING_QUEUE:
      return Object.assign({}, state, {
        previousState: state.previousState,
        state: CHAT_STATUS.LEAVING_QUEUE
      });
    case BACK_TO_QUEUE:
      return Object.assign({}, state, {
        previousState: null,
        state: state.previousState || CHAT_STATUS.QUEUE
      });
    case RECEIVE_CHAT_AN_ADVISOR:
      return Object.assign({}, state, {
        dfCaseId: action.caseId,
        dfId: action.id,
        dfKey: action.sessionKey,
        dfAffinity: action.affinityToken,
        dfSequence: 2,
        // Start at 2 for the first message (1 is used by ChasitorInit)
        dfClosedMessage: action.message,
        liveAgentUrl: action.agentUrl
      });
    case GO_TO_ERROR_SCREEN:
      return Object.assign({}, state, {
        state: CHAT_STATUS.NO_CASE_CODE
      });
    case "INCREMENT_DF_SEQUENCE":
      return Object.assign({}, state, {
        dfSequence: (state.dfSequence || 1) + 1
      });
    case RESET_CHAT_STATE:
      return initialState;
    case RESET_CONFIG_STATE:
      return state;
    case CHAT_STATUS.CALL_CENTER_CLOSED:
      return {
        ...state,
        state: CHAT_STATUS.CALL_CENTER_CLOSED
      };
    case SET_CASE_ID:
      return Object.assign({}, state, {
        dfCaseId: action.caseId
      });
    case SET_CHATBOT_SENDING:
      return Object.assign({}, state, {
        sending: !!action.sending
      });
    default:
      return state;
  }
};
export {
  ChatBotReducer as default
};
//# sourceMappingURL=ChatBotReducer.js.map
